module.exports = __webpack_public_path__ + "img/icon_jrtb@2x.4bbafe3d.png";